import React from 'react';
import { Check, X } from 'lucide-react';

const PasswordRules = ({ password }) => {
  const rules = [
    {
      id: 'length',
      label: 'At least 8 characters',
      test: (p) => p.length >= 8,
    },
    {
      id: 'letter',
      label: 'Contains at least one letter',
      test: (p) => /[a-zA-Z]/.test(p),
    },
    {
      id: 'number',
      label: 'Contains at least one number',
      test: (p) => /\d/.test(p),
    },
  ];

  if (!password) {
    return null; // or could show grayed out rules, but it might clutter UI initially
  }

  return (
    <div className="mt-2 text-sm">
      <p className="text-gray-600 mb-1 font-medium">Password must contain:</p>
      <ul className="space-y-1">
        {rules.map((rule) => {
          const isMet = rule.test(password);
          return (
            <li key={rule.id} className={`flex items-center gap-2 ${isMet ? 'text-green-600' : 'text-gray-500'}`}>
              {isMet ? (
                <Check size={16} className="text-green-500" />
              ) : (
                <X size={16} className="text-red-400" />
              )}
              <span className={isMet ? 'text-green-700' : 'text-gray-600'}>{rule.label}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default PasswordRules;
